import { AppConfig } from '@/constants/residents/config';

export function buildFeedbackUrl(email?: string | null): string {
  const base = AppConfig.URLS.FEEDBACK;
  if (email && email.trim().length > 0) {
    return `${base}?email=${encodeURIComponent(email)}`;
  }
  return base;
}


